import React from 'react'
import { getImages } from '../const'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
      <footer className='footer-wrap'>
        <div className='container'>
          <div className='d-flex justify-content-between footer-flex'>
            <div className='pe-3'>
              <Link to="/" className='footer-logo mb-3 d-inline-block'><img src={getImages('mclaren-orlando-logo-white.png')} alt='logo'/></Link>
              <div>
                <p className='mb-1'>1111 S Orlando Ave Winter Park, FL 32789</p>
                <p className='mb-1'>Sales: <a href='tel:4079880111' className='text-orange'>407-988-0111</a></p>
                <p className='mb-1'>Service: <a href='tel:4079882545' className='text-orange'>407-988-2545</a></p>
                <p className='mb-1'>Parts: <a href='tel:4079882586' className='text-orange'>407-988-2586</a></p>
              </div>
            </div>
            <div className='d-none d-lg-block'>
              <div className='xs-title fw-bold text-uppercase mb-4'>Store Hours</div>
              <div className='mnw-300 xs-title opacity-0-5'>
                <div className='row mb-2'>
                  <div className='col-6'>Monday - Friday</div>
                  <div className='col-6 fw-bold'>9am - 6pm</div>
                </div>
                <div className='row mb-2'>
                  <div className='col-6'>Saturday</div>
                  <div className='col-6 fw-bold'>10am - 4pm</div>
                </div>
                <div className='row mb-2'>
                  <div className='col-6'>Sunday</div>
                  <div className='col-6 fw-bold'>Closed</div>
                </div>
              </div>
            </div>
            <div className='d-none d-lg-block'>
              <div className='xs-title fw-bold text-uppercase mb-4'>Service Hours</div>
              <div className='mnw-300 xs-title opacity-0-5'>
                <div className='row mb-2'>
                  <div className='col-6'>Monday - Friday</div>
                  <div className='col-6 fw-bold'>8am - 5pm</div>
                </div>
                <div className='row mb-2'>
                  <div className='col-6'>Saturday</div>
                  <div className='col-6 fw-bold'>Closed</div>
                </div>
                <div className='row mb-2'>
                  <div className='col-6'>Sunday</div>
                  <div className='col-6 fw-bold'>Closed</div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-xl-flex align-items-center footer-bottom mt-5'>
            <div className='order-xl-3 ms-md-auto social-links'>
              <a href='https://www.facebook.com/profile.php?id=61573187026431' target='_blank'><img src={getImages('facebook-icon.png')}/></a>
              <a href='https://www.instagram.com/mclarenorlando/' target='_blank'><img src={getImages('instagram-icon.png')}/></a>
              <a href='https://www.linkedin.com/company/mclaren-orlando/' target='_blank'><img src={getImages('linkedin-icon.png')}/></a>
              <a href='https://www.tiktok.com/tag/mclarenorlando' target='_blank'><img src={getImages('tiktok-icon.png')}/></a>
            </div>
            <div className='xs-title order-md-1 copyright'>&copy; 2025 McLaren Orlando LLC. All Rights Reserved.</div>
            <div className='fb-menu xs-title order-md-2'>
              <ul className='d-inline-flex align-items-center'>
                <li>
                  <Link to='/sitemap' className='text-orange'>Sitemap</Link>
                </li>
                <li>
                  <Link to='/privacy-policy' className='text-orange'>Privacy Policy</Link>
                </li>
                <li>
                  <Link to='/terms-and-conditions' className='text-orange'>Terms and Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer